import apiService from '@/member/services/apiService'

const getDefaultState = () => {
  return {}
}

const state = getDefaultState()

const mutations = {}

const actions = {
  async list({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.creation-cost-subsidy.list'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async create({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.creation-cost-subsidy.create'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async update({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.creation-cost-subsidy.update'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async getRecord({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.creation-cost-subsidy.get_record'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async delete({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.creation-cost-subsidy.delete'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
}

export default {
  state,
  mutations,
  actions,
}
